import type { TypographyV3Props } from '@jouzen/ecom-components';
import { TypographyV3 } from '@jouzen/ecom-components';
import { cx } from 'class-variance-authority';
import { useTranslations } from 'next-intl';

interface ColorBlockProps {
  readonly backgroundColor: string;
  readonly color?: TypographyV3Props['color'];
  readonly className?: string;
  readonly tx: string;
}

const ColorBlock = ({
  backgroundColor,
  color = null,
  className,
  tx,
}: ColorBlockProps): JSX.Element => {
  const t = useTranslations();
  return (
    <TypographyV3
      Element="li"
      variant="body-small"
      color={color}
      className={cx('flex items-end p-4 pt-8', className)}
      style={{ backgroundColor }}
    >
      {t.rich(tx)}
    </TypographyV3>
  );
};

export default ColorBlock;
